module.exports = __webpack_public_path__ + "e72c98b060dccec4d2f2f2d679460440.pdf";